// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.WalletBackendNotSignedInException
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap

fun WalletBackendNotSignedInException.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "Ch4nNnd_gKYr6y33K2SYeEgcDKEBlLgytRNr77rlQBc")
val WalletBackendNotSignedInException_cborSchemaId = ByteString(10, 30, 39, 54, 119, 127, -128, -90, 43, -21, 45, -9, 43, 100, -104, 120, 72, 28, 12, -95, 1, -108, -72, 50, -75, 19, 107, -17, -70, -27, 64, 23)

fun WalletBackendNotSignedInException.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "WalletBackendNotSignedInException")
    return builder.end().build()
}

fun WalletBackendNotSignedInException_fromDataItem(dataItem: DataItem): WalletBackendNotSignedInException {
    return WalletBackendNotSignedInException(
    )
}
